import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("autopost_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      const detail = err?.response?.data?.detail || "";
      const isSessionReplaced = typeof detail === "string" && detail.startsWith("session_replaced");
      localStorage.removeItem("autopost_token");
      localStorage.removeItem("autopost_user");
      if (window.location.pathname !== "/login") {
        window.location.href = isSessionReplaced ? "/login?reason=session_replaced" : "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const mediaUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
};

/**
 * Converts any error shape into a renderable string.
 * FastAPI 422 returns `detail` as an array of `{type, loc, msg, input, ctx}`.
 * Other endpoints return a plain string. Network errors expose `message`.
 */
export const getErrorMessage = (err, fallback = "Erro inesperado") => {
  if (!err) return fallback;
  const detail = err?.response?.data?.detail ?? err?.message ?? err;
  if (Array.isArray(detail)) {
    return (
      detail
        .map((e) => (typeof e === "string" ? e : e?.msg || JSON.stringify(e)))
        .filter(Boolean)
        .join(", ") || fallback
    );
  }
  if (detail && typeof detail === "object") {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return String(detail || fallback);
};
